export const textareaFields = [
  'comment__comment',
  'structural-design__description',
  'structural-design__inlay-description',
  'other__packaging-details'
]
